var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-create"},[_c('button',{staticClass:"btn btn-primary",on:{"click":_vm.templatePage}},[_c('i',{staticClass:"icon icon-plus mr-1"}),_c('span',[_vm._v(_vm._s(_vm.btnText))])])])}
var staticRenderFns = []

export { render, staticRenderFns }